import type { Components, Theme } from '@mui/material/styles'

import { spacing } from '@/themes/tokens'

declare module '@mui/material/Divider' {
  interface DividerPropsVariantOverrides {
    sectionDivider: true
  }
}

export const MuiDividerOverride: Components<Theme>['MuiDivider'] = {
  variants: [
    {
      props: { variant: 'sectionDivider' },
      style: ({ theme }) => ({
        marginBottom: theme.spacing(spacing.sm),
      }),
    },
  ],
}
